import React from "react";
import { observer } from "mobx-react";
import { WrappedLink } from "@components/navigation";
import { getCurrentCulture } from "@utils";
import { EventType } from "@gp/models";
import TeamIconBB from "@components/icons/TeamIconBB";

type QuickPlayPopupsTeamsProps = {
	sportData: {
		eventType?: any;
		eventName?: string | null;
		showCountryFlag?: boolean;
		teamOneCountryCode?: string;
		teamTwoCountryCode?: string;
		teamOneJerseyTypeAbrv?: string;
		teamTwoJerseyTypeAbrv?: string;
		teamOneName?: string;
		teamTwoName?: string;
	};
	eventId?: string;
	className?: string;
	containerClassName?: string;
	iconClassName?: string;
	teamNameClassName?: string;
	isLive?: boolean;
	isLinkDisabled?: boolean;
	isBetBuilder?: boolean;
};

export const QuickPlayPopupsTeams = observer(
	(props: QuickPlayPopupsTeamsProps) => {
		const {
			containerClassName = "card--qp__competitor card--bbp__competitor",
			iconClassName = "card--qp__icon card--bbp__icon u-icon u-icon--base",
			teamNameClassName = "card--qp__team card--bbp__team",
		} = props;

		if (
			props.sportData.eventType &&
			props.sportData.eventType !== EventType.NORMAL &&
			props.sportData.eventName != ""
		) {
			return <div>{props.sportData.eventName}</div>;
		}

		const linkUrl = `/${getCurrentCulture()}/sports/full/event/${
			props.eventId
		}?${props.isBetBuilder ? "bb=true" : ""}`;

		const content = (
			<div>
				<div className={containerClassName}>
					<TeamIconBB
						showCountryFlag={props.sportData.showCountryFlag}
						flagCode={props.sportData.teamOneCountryCode}
						opponentFlagCode={props.sportData.teamTwoCountryCode}
						jerseyTypeAbrv={props.sportData.teamOneJerseyTypeAbrv}
						opponentJerseyType={
							props.sportData.teamTwoJerseyTypeAbrv
						}
						className={iconClassName}
					/>
					<span className={teamNameClassName}>
						{props.sportData.teamOneName}
					</span>
				</div>
				<div className={containerClassName}>
					<TeamIconBB
						showCountryFlag={props.sportData.showCountryFlag}
						flagCode={props.sportData.teamTwoCountryCode}
						opponentFlagCode={props.sportData.teamOneCountryCode}
						jerseyTypeAbrv={props.sportData.teamTwoJerseyTypeAbrv}
						opponentJerseyType={
							props.sportData.teamOneJerseyTypeAbrv
						}
						className={iconClassName}
					/>
					<span className={teamNameClassName}>
						{props.sportData.teamTwoName}
					</span>
				</div>
			</div>
		);

		return props.isLinkDisabled ? (
			content
		) : (
			<WrappedLink
				to={linkUrl}
				className="card--qp__link card--qp__match card--bbp__match"
				onClick={(e) => e.stopPropagation()}
			>
				{content}
			</WrappedLink>
		);
	}
);
